import {
    lazyLoadInternetMessageIdAttachment,
    lazyLoadSxSWithReadingPaneItem,
} from 'owa-mail-sxs-view';
import { AttachmentSelectionSource } from 'owa-sxs-store';

export interface AttachmentRouteParamaters {
    itemId: string;
    attachmentId: string;
    groupDomain?: string;
    groupAlias?: string;
    isEdit?: string;
    startTime?: string;
}

async function deepLinkAttachmentRouteHandler(parameters: AttachmentRouteParamaters) {
    if (parameters.itemId && parameters.attachmentId) {
        const loadSxSWithReadingPaneItem = await lazyLoadSxSWithReadingPaneItem.import();
        const groupId =
            parameters.groupDomain && parameters.groupAlias
                ? `${parameters.groupAlias}@${parameters.groupDomain}`
                : null;
        const isEdit: boolean = parameters.isEdit === 'true';
        await loadSxSWithReadingPaneItem(
            parameters.itemId,
            parameters.attachmentId,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (30,13): Argument of type 'string | null' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            groupId,
            AttachmentSelectionSource.Deeplink,
            null /* instrumentationContext */,
            isEdit,
            Number(parameters.startTime)
        );
    }
}

export default deepLinkAttachmentRouteHandler;

export interface InternetMessageIdAttachmentRouteParamaters {
    base64EncodedInternetMessageId: string;
    attachmentIndex: string;
}

function deepLinkInternetMessageIdAttachmentRouteHandler(
    parameters: InternetMessageIdAttachmentRouteParamaters
) {
    lazyLoadInternetMessageIdAttachment.importAndExecute(
        atob(parameters.base64EncodedInternetMessageId),
        Number(parameters.attachmentIndex)
    );
}

export { deepLinkInternetMessageIdAttachmentRouteHandler };
